module.exports = __webpack_public_path__ + "static/media/demo-tournament-bg.a13c15d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/demo-tournament-bg.png
// module id = 667
// module chunks = 103